"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.McpToolAddApprovalRequestModel = void 0;
var McpToolAddApprovalRequestModel_1 = require("./McpToolAddApprovalRequestModel");
Object.defineProperty(exports, "McpToolAddApprovalRequestModel", { enumerable: true, get: function () { return McpToolAddApprovalRequestModel_1.McpToolAddApprovalRequestModel; } });
